import React from "react";

// ctrl+s wordmark — three rounded outlined cells: "ctrl" + "+" + "S".
// Source SVG: src/assets/logos/ctrl-s-logo.svg
//
// Color strategy: the wrapper SVG sets `currentColor` via Tailwind's
// `text-black dark:text-zinc-100`. Inner shapes opt into `fill="currentColor"`
// (text/icon glyphs) or `stroke="currentColor"` (cell outlines). This way one
// utility class drives both fill and stroke uniformly across the logo and
// inverts cleanly in dark mode — same pattern used by the sister logo
// components (DefaultLogo / SmallLogo / CollapsedLogo).
// `className` carries the height only. It defaults to the 36px every caller used
// when the height was hardcoded here, so auth, registration and the nav widget are
// unchanged; the mobile header overrides it, where a 36px wordmark renders ~147px
// wide and eats 43% of a 375px screen.
const PlatformLogo = ({ className = 'h-[36px]' }) => (
  <svg
    viewBox="0 0 212 52"
    xmlns="http://www.w3.org/2000/svg"
    className={`platform-logo ${className} text-black dark:text-zinc-100`}
  >
    <g fill="none" fillRule="evenodd">
      {/* "S" cell */}
      <g transform="translate(160 0)">
        <rect stroke="currentColor" strokeWidth="2" x="1" y="1" width="50" height="50" rx="5" />
        <path
          fill="currentColor"
          d="M22.382 32.037c.875.616 2.01.923 3.403.923 1.242 0 2.25-.223 3.024-.67.773-.445 1.16-1.043 1.16-1.79 0-.628-.178-1.099-.533-1.412-.354-.314-.83-.537-1.426-.67-.596-.132-1.515-.27-2.757-.416-1.698-.193-3.1-.452-4.203-.778-1.102-.325-1.99-.844-2.661-1.556-.672-.712-1.008-1.67-1.008-2.877 0-1.134.336-2.142 1.008-3.022.671-.88 1.597-1.562 2.776-2.045 1.18-.483 2.516-.724 4.012-.724 2.46 0 4.456.519 5.99 1.556 1.534 1.038 2.364 2.498 2.491 4.38h-3.993c-.102-.845-.545-1.539-1.331-2.081-.786-.543-1.775-.814-2.967-.814-1.191 0-2.156.217-2.89.651-.735.434-1.103 1.025-1.103 1.773 0 .555.184.971.551 1.248.368.278.83.471 1.388.58.558.108 1.458.235 2.7.38 1.674.169 3.081.428 4.222.778 1.142.35 2.054.904 2.739 1.665.684.76 1.026 1.791 1.026 3.094 0 1.158-.355 2.177-1.065 3.058-.71.88-1.686 1.556-2.928 2.026-1.242.471-2.636.706-4.184.706-2.612 0-4.722-.56-6.332-1.682-1.61-1.123-2.44-2.673-2.491-4.65h3.956c.076.964.551 1.754 1.426 2.37"
        />
      </g>
      {/* "+" cell */}
      <g transform="translate(106 0)">
        <rect stroke="currentColor" strokeWidth="2" x="1" y="1" width="50" height="50" rx="5" />
        <path fill="currentColor" d="M27.876 18v6.697H34v3.606h-6.124V35h-3.79v-6.697H18v-3.606h6.087V18z" />
      </g>
      {/* "ctrl" cell */}
      <rect stroke="currentColor" strokeWidth="2" x="1" y="1" width="102" height="50" rx="5" />
      <path
        fill="currentColor"
        d="M33.39 37.566c-1.865 0-3.51-.385-4.934-1.156a8.02 8.02 0 0 1-3.296-3.29c-.773-1.424-1.16-3.06-1.16-4.91s.392-3.475 1.178-4.874a8.172 8.172 0 0 1 3.333-3.255c1.437-.77 3.1-1.156 4.99-1.156 2.357 0 4.284.599 5.782 1.796 1.497 1.198 2.43 2.828 2.8 4.892h-4.089c-.27-1.044-.81-1.874-1.62-2.49-.81-.617-1.805-.925-2.983-.925-1.596 0-2.879.557-3.849 1.672-.97 1.115-1.454 2.561-1.454 4.34 0 1.802.485 3.267 1.454 4.393.97 1.127 2.253 1.69 3.849 1.69 1.227 0 2.246-.314 3.056-.943.81-.628 1.338-1.476 1.584-2.543h4.051c-.369 2.11-1.314 3.765-2.836 4.963-1.522 1.197-3.474 1.796-5.855 1.796M45.096 23.181v-3.273h3.222v-4.927h3.945v4.927h4.453v3.273h-4.453v9.199c0 .689.145 1.177.435 1.464.29.287.784.43 1.484.43h2.969v3.273h-3.765c-1.762 0-3.047-.39-3.856-1.171-.808-.781-1.212-1.986-1.212-3.617V23.18h-3.222ZM71.21 23.39h-1.704c-1.585 0-2.733.5-3.443 1.5s-1.065 2.27-1.065 3.811v8.865h-3.834v-17.66h3.408l.426 2.656a5.677 5.677 0 0 1 2.024-1.949c.828-.472 1.94-.707 3.336-.707h.852v3.483ZM75.233 37.547h4.018V14h-4.018z"
      />
    </g>
  </svg>
);

export default PlatformLogo;
